import React, { Component,Fragment }  from 'react';
import '../../style.css';
import {
    Button, Card, DatePicker, Dropdown, Form,
    Input, List, message, Modal, Radio, Space, Table, Tag, Menu, Typography, ConfigProvider, PageHeader, Select
} from "antd";
import {DeleteOutlined, EditOutlined,CloseOutlined,SearchOutlined} from "@ant-design/icons";
import {fetchPost} from "../../static/util/fetch";
import moment from "moment";
import locale from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
const { Column } = Table;
const { Paragraph } = Typography;
const Option = Select.Option;

class IPList extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            IP:[],//知识产权列表
            companyNames:[],//公司名称数组
            productNames:[],//产品名称数组
            projectNames:[],//项目名称数组
            addProductNames:[],//添加时产品名称数组
            addProjectNames:[],//添加时项目名称数组
            chooseCompanyName:'请选择公司',//查找时选中的公司名称
            chooseProductName:'请选择产品',//查找时选中的产品名称
            chooseProjectName:'请选择项目',//查找时选中的项目名称
            chooseAddCompanyName:'请选择公司',//添加时选中的公司名称
            chooseAddProductName:'请选择产品',//添加时选中的产品名称
            chooseAddProjectName:'请选择项目',//添加时选中的项目名称
            chooseCompanyId:'请选择公司',//查找时选中的公司名称
            chooseProductId:'请选择产品',//查找时选中的产品名称
            chooseProjectId:'请选择项目',//查找时选中的项目名称
            chooseAddCompanyId:'请选择公司',//添加时选中的公司名称
            chooseAddProductId:'请选择产品',//添加时选中的产品名称
            chooseAddProjectId:'请选择项目',//添加时选中的项目名称
            edit_visible:false,
            delete_visible:false,
            add_visible:false,
            editId:0,//获取单个知识产权时的id
            deleteId:0,//删除某个产权时的id
            chooseProductButtonDisabled:false,
            authorizationTimeDisabled:true,
            companyName:"",
            productName:"",
            projectName:"",
            patentName:"",
            category:'请选择种类',//种类名称
            categoryCode:'',//种类
            type:"",//类别
            applyNumber:"",
            applyTime:'',
            authorizationNumber:"",
            authorizationTime:"",
            access:"",
            accessName:'请选择获得方式',
            obligee:'',
            legalStatus:'',
            history:'',
            status:0,
            newPatentName:"",
            newCategory:"",
            newCategoryCode:'',
            newType:'',
            newApplyNumber:"",
            newApplyTime:'',
            newAuthorizationNumber:"",
            newAuthorizationTime:"",
            newAccess:"",
            newAccessName:'',
            newObligee:"",
            newLegalStatus:'',
            newHistory:'',
            newStatus:0,
            searchStatus:true,
        }
        this.chooseCompany = this.chooseCompany.bind(this);
        this.chooseProduct = this.chooseProduct.bind(this);
        this.chooseProject = this.chooseProject.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.addIP = this.addIP.bind(this);
        this.uploadIP = this.uploadIP.bind(this);
        this.deleteIP = this.deleteIP.bind(this);
        // this.cancelCompanyName = this.cancelCompanyName.bind(this);
        // this.cancelProductName  = this.cancelProductName.bind(this);
        // this.cancelProjectName = this.cancelProjectName.bind(this);
        this.getIPList = this.getIPList.bind(this);
        this.patentNameChange = this.patentNameChange.bind(this);
        this.categoryChange = this.categoryChange.bind(this);
        this.applyNumberChange = this.applyNumberChange.bind(this);
        this.authorizationNumberChange = this.authorizationNumberChange.bind(this);
        this.applyTimeChange = this.applyTimeChange.bind(this);
        this.authorizationTimeChange = this.authorizationTimeChange.bind(this);
        this.legalStatusChange = this.legalStatusChange.bind(this);
        this.historyChange = this.historyChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.obligeeChange = this.obligeeChange.bind(this);
        this.patentNameChangeNew = this.patentNameChangeNew.bind(this);
        this.categoryChangeNew = this.categoryChangeNew.bind(this);
        this.applyNumberChangeNew = this.applyNumberChangeNew.bind(this);
        this.authorizationNumberChangeNew = this.authorizationNumberChangeNew.bind(this);
        this.applyTimeChangeNew = this.applyTimeChangeNew.bind(this);
        this.authorizationTimeChangeNew = this.authorizationTimeChangeNew.bind(this);
        this.legalStatusChangeNew = this.legalStatusChangeNew.bind(this);
        this.historyChangeNew = this.historyChangeNew.bind(this);
        this.statusChangeNew = this.statusChangeNew.bind(this);
        this.obligeeChangeNew = this.obligeeChangeNew.bind(this);
    }
    componentDidMount(){
        // this.setState(()=>({
        //     loading:true
        // }))
        // fetchPost(global.constants.getAllPatent,{})
        //     .then(
        //         res => {
        //             if(res.code === 200) {
        //                 this.setState(()=>({
        //                     IP:res.data,
        //                     loading:false
        //                 }))
        //             }
        //             else{
        //                 this.setState(()=>({
        //                     loading:false
        //                 }))
        //                 message.info(res.msg)
        //             }
        //         }
        //     )
        fetchPost(global.constants.getCompanyNameList,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            companyNames:res.data,
                        }))
                    }
                    else{
                        message.info(res.msg)
                    }
                }
            )
    }
    getAllPatentByCompany(){
        if(this.state.chooseCompanyName !='请选择公司') {
            this.setState(()=>({
                chooseProductName:'请选择产品',
                chooseProjectName:'请选择项目',
            }))
            fetchPost(global.constants.getAllPatent, {companyId: this.state.chooseCompanyId})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                IP: res.data,
                                loading: false
                            }))
                        } else {
                            this.setState(() => ({
                                loading: false
                            }))
                            message.info(res.msg)
                        }
                    }
                )
        }
    }
    chooseCompany = (e)=>{
        const value = e
        this.setState(()=>({
            chooseCompanyName:value,
            chooseProductName:'请选择产品',
            chooseProjectName:'请选择项目',
            chooseProductButtonDisabled:false,
        }))
        //获取该公司所有产品的名字
        this.state.companyNames.find((obj) => {
            if(obj.companyName === value) {
                this.setState(() => ({
                    chooseCompanyId: obj.id
                }))
                fetchPost(global.constants.getCompanyProductList, {companyId: obj.id})
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    productNames: res.data,
                                }))
                            } else {
                                message.info("该公司没有产品").then()
                                this.setState(() => ({
                                    productNames: [],
                                }))
                            }
                        }
                    )
            //获取直接属于该公司的项目名称
            fetchPost(global.constants.getProjectByCompany,{companyId: obj.id})
                .then(
                    res => {
                        if(res.code === 200) {
                            this.setState(()=>({
                                projectNames:res.data,
                            }))
                        }
                        else{
                            this.setState(()=>({
                                projectNames:[],
                            }))
                        }
                    }
                )
            }})
    }
    chooseProduct = (e)=>{
        const value = e
        this.setState(()=>({
            chooseProductName:value,
            chooseProjectName:"请选择项目"
        }))
        this.state.productNames.find((obj) => {
            if(obj.productName === value) {
                this.setState(() => ({
                    chooseProductId: obj.id
                }))
                let params ={
                    companyId: this.state.chooseCompanyId,
                    productId: obj.id,
                }
                fetchPost(global.constants.getProjectByProduct, params)
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    projectNames: res.data,
                                }))
                            } else {
                                message.info("该产品没有项目")
                                this.setState(() => ({
                                    projectNames: []
                                }))

                            }
                        }
                    )
            }})
    }
    chooseProject = (e)=>{
        const value = e
        this.setState(()=>({
            chooseProjectName:value
        }))
        if(this.state.chooseProductName =='请选择产品'){
            this.setState(()=>({
                chooseProductButtonDisabled: true
            }))
        }
        this.state.projectNames.find((obj) => {
            if(obj.projectName === value) {
                this.setState(() => ({
                    chooseProjectId: obj.id
                }))
            }})
    }
    clearPath(){
        this.setState(()=>({
            chooseCompanyName:'请选择公司',
            chooseProductName:'请选择产品',
            chooseProjectName:'请选择项目',
            productNames:[],
            projectNames:[],
            searchStatus:true,
        }))
    }
    getIPList(){
        this.setState(()=>({
            loading:true,
        }))
        let params = {
            companyName:this.state.chooseCompanyName,
            productName: this.state.chooseProductName,
            projectName: this.state.chooseProjectName,
        }
        if(this.state.chooseCompanyName =='请选择公司' && this.state.chooseProductName == '请选择产品' && this.state.chooseProjectName == '请选择项目'){
            message.info('请选择查找路径').then()
            this.setState(()=>({
                loading:false
            }))
        }
        if(this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName == '请选择产品' && this.state.chooseProjectName == '请选择项目') {
            fetchPost(global.constants.getPatentByCompany, {companyId: this.state.chooseCompanyId})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                IP: res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        } else {
                            this.setState(() => ({
                                IP: [],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("没有直接属于该公司的知识产权")
                        }
                    }
                )
        }
        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName === '请选择产品' && this.state.chooseProjectName !== '请选择项目') {
            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                IP: res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        } else {
                            this.setState(() => ({
                                IP: [],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("该公司的"+this.state.chooseProjectName+"下没有绑定的知识产权")
                        }
                    }
                )
            }
        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProjectName == '请选择项目' && this.state.chooseProductName != '请选择产品') {
            fetchPost(global.constants.getPatentByProduct, {productId: this.state.chooseProductId})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                IP: res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        } else {
                            this.setState(() => ({
                                IP: [],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("该公司的"+this.state.chooseProductName+"下没有绑定的知识产权")
                        }
                    }
                )
            }
        if(this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName != '请选择产品' && this.state.chooseProjectName !=  "请选择项目"){
            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                IP: res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        } else {
                            this.setState(()=>({
                                IP:[],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("该公司的"+this.state.chooseProductName+"的"+this.state.chooseProjectName+"下没有绑定的知识产权")
                        }
                    }
                )
        }
        }
    hideModal(){
        this.setState(()=>({
            edit_visible:false,
            delete_visible:false,
            add_visible:false,
        }))
    }
    handleEditClick = (e)=>{
        const value = e.id;
        this.setState(()=>({
            editId:value,
        }))
        const date = new Date()
        fetchPost(global.constants.getPatentMessage,{id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            newPatentName:res.data.patentName,
                            newType:res.data.type,
                            newCategory:res.data.category,
                            newCategoryCode:res.data.categoryCode,
                            newApplyNumber:res.data.applyNumber,
                            newAuthorizationNumber:res.data.authorizationNumber,
                            newApplyTime:res.data.applyTime === null ? date : res.data.applyTime,
                            newAuthorizationTime:res.data.authorizationTime === null ? date : res.data.authorizationTime,
                            newAccess:res.data.access,
                            newAccessName:res.data.accessName,
                            newRemark:res.data.remark,
                            newStatus:res.data.status,
                            newLegalStatus:res.data.legalStatus,
                            newHistory:res.data.history,
                            newObligee:res.data.obligee,
                            edit_visible:true,
                        }))
                    }
                }
            )
    }
    uploadIP(){
        let params = {
            id:this.state.editId,
            patentName:this.state.newPatentName,
            type:this.state.newType,
            category:this.state.newCategory,
            categoryCode:this.state.newCategoryCode,
            applyNumber:this.state.newStatus === 1?'':this.state.newApplyNumber,
            authorizationNumber:this.state.newStatus === 0?'':this.state.newAuthorizationNumber,
            applyTime:this.state.newStatus === 1?'':this.state.newApplyTime,
            authorizationTime:this.state.newStatus === 0?'':this.state.newAuthorizationTime,
            access:this.state.newAccess,
            accessName: this.state.newAccessName,
            remark:this.state.newRemark,
            legalStatus: this.state.newLegalStatus,
            history: this.state.newHistory,
            status:this.state.newStatus,
            obligee:this.state.newObligee,
        }
        fetchPost(global.constants.updatePatent,params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success(res.msg)
                        this.setState(()=>({
                            edit_visible:false
                        }))
                        //更新后重新请求
                        if(this.state.chooseCompanyName != '请选择公司' &&this.state.chooseProductName == '请选择产品' && this.state.chooseProjectName == '请选择项目') {
                            fetchPost(global.constants.getPatentByCompany, {companyId: this.state.chooseCompanyId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName === '请选择产品' && this.state.chooseProjectName !== '请选择项目') {
                            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProjectName == '请选择项目' && this.state.chooseProductName != '请选择产品') {
                            fetchPost(global.constants.getPatentByProduct, {productId: this.state.chooseProductId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if(this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName != '请选择产品' && this.state.chooseProjectName !=  "请选择项目"){
                            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(()=>({
                                                IP:[]
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                }
            )
    }
    handleDeleteClick(e){
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deleteIP(){
        fetchPost(global.constants.deletePatent,{id:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除知识产权成功').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        //更新后重新请求
                        if(this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName == '请选择产品' && this.state.chooseProjectName == '请选择项目') {
                            fetchPost(global.constants.getPatentByCompany, {companyId: this.state.chooseCompanyId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName === '请选择产品' && this.state.chooseProjectName !== '请选择项目') {
                            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if (this.state.chooseCompanyName != '请选择公司' && this.state.chooseProjectName == '请选择项目' && this.state.chooseProductName != '请选择产品') {
                            fetchPost(global.constants.getPatentByProduct, {productId: this.state.chooseProductId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(() => ({
                                                IP: []
                                            }))
                                        }
                                    }
                                )
                        }
                        if(this.state.chooseCompanyName != '请选择公司' && this.state.chooseProductName != '请选择产品' && this.state.chooseProjectName !=  "请选择项目"){
                            fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            this.setState(() => ({
                                                IP: res.data,
                                            }))
                                        } else {
                                            this.setState(()=>({
                                                IP:[]
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                }
            )
    }
    handleAddClick(){
            this.setState(() => ({
                chooseAddCompanyName:'请选择公司',
                chooseAddProductName:'请选择产品',
                chooseAddProjectName:'请选择项目',
                patentName:"",
                type:"",
                category:'请选择种类',
                categoryCode:'',
                applyNumber:"",
                applyTime:'',
                authorizationNumber:"",
                authorizationTime:"",
                access:"",
                accessName:'请选择获得方式',
                obligee:'',
                legalStatus:'',
                history:'',
                status:0,
                add_visible: true,
            }))
    }
    checkIP(){
        fetchPost(global.constants.checkPatentName,{patentName:this.state.patentName})
            .then(
                res=>{
                    if(res.code === -1){
                        alert("该产权已存在")
                    }
                }
            )
    }
    addIP(){
        let params = {
            companyId:this.state.chooseAddCompanyName== '请选择公司'?0:this.state.chooseAddCompanyId,
            productId: this.state.chooseAddProductName == '请选择产品'?0:this.state.chooseAddProductId,
            projectId:this.state.chooseAddProjectName== '请选择项目'?0:this.state.chooseAddProjectId,
            patentName:this.state.patentName,
            category:this.state.category,
            categoryCode:this.state.categoryCode,
            type:this.state.type,
            applyNumber:this.state.status === 1?'':this.state.applyNumber,
            authorizationNumber:this.state.status === 0?'':this.state.authorizationNumber,
            applyTime:this.state.status === 1?'':this.state.applyTime,
            authorizationTime:this.state.status === 0?'':this.state.authorizationTime,
            access:this.state.access,
            accessName:this.state.accessName,
            remark:this.state.remark,
            legalStatus: this.state.legalStatus,
            history: this.state.history,
            status:this.state.status,
            obligee:this.state.obligee,
        }
        if(this.state.patentName === ''||this.state.category === ''||this.state.status=== ''
            ||(this.state.status=== 1 && this.state.authorizationNumber === '')
            ||(this.state.status=== 1 && this.state.authorizationTime === '')
            ||(this.state.status=== 0 && this.state.applyNumber === '')
            ||(this.state.status=== 0 && this.state.applyTime === '')||
            this.state.accessName === ''||this.state.legalStatus === ''){
            message.info("请检查知识产权信息是否填写完整")
        }else{
            if(this.state.addCompanyName ==='请选择公司'){
                message.error("请先选择公司再添加知识产权").then()
            }else{
                fetchPost(global.constants.addPatent, params)
                    .then(
                        res => {
                            if (res.code === 200) {
                                message.success('添加成功');
                                // this.setState(() => ({
                                //     add_visible: false
                                // }))
                                if (this.state.chooseAddCompanyName != '请选择公司' && this.state.chooseAddProductName == '请选择产品' && this.state.chooseAddProjectName == '请选择项目') {
                                    this.setState(()=>({
                                        chooseCompanyName:this.state.chooseAddCompanyName,
                                        chooseProductName:this.state.chooseAddProductName,
                                        chooseProjectName:this.state.chooseAddProjectName,
                                        chooseCompanyId:this.state.chooseAddCompanyId,
                                        chooseProductId:this.state.chooseAddProductId,
                                        chooseProjectId:this.state.chooseAddProjectId
                                    }))
                                    fetchPost(global.constants.getPatentByCompany, {companyId: this.state.chooseCompanyId})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        IP: res.data,
                                                    }))
                                                } else {
                                                    this.setState(() => ({
                                                        IP: []
                                                    }))
                                                }
                                            }
                                        )
                                }
                                if (this.state.chooseAddCompanyName != '请选择公司' && this.state.chooseAddProductName === '请选择产品' && this.state.chooseAddProjectName !== '请选择项目') {
                                    this.setState(()=>({
                                        chooseCompanyName:this.state.chooseAddCompanyName,
                                        chooseProductName:this.state.chooseAddProductName,
                                        chooseProjectName:this.state.chooseAddProjectName,
                                        chooseCompanyId:this.state.chooseAddCompanyId,
                                        chooseProductId:this.state.chooseAddProductId,
                                        chooseProjectId:this.state.chooseAddProjectId
                                    }))
                                    fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        IP: res.data,
                                                    }))
                                                } else {
                                                    this.setState(() => ({
                                                        IP: []
                                                    }))
                                                }
                                            }
                                        )
                                }
                                if (this.state.chooseAddCompanyName != '请选择公司' && this.state.chooseAddProjectName == '请选择项目' && this.state.chooseAddProductName != '请选择产品') {
                                    this.setState(()=>({
                                        chooseCompanyName:this.state.chooseAddCompanyName,
                                        chooseProductName:this.state.chooseAddProductName,
                                        chooseProjectName:this.state.chooseAddProjectName,
                                        chooseCompanyId:this.state.chooseAddCompanyId,
                                        chooseProductId:this.state.chooseAddProductId,
                                        chooseProjectId:this.state.chooseAddProjectId
                                    }))
                                    fetchPost(global.constants.getPatentByProduct, {productId: this.state.chooseProductId})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        IP: res.data,
                                                    }))
                                                } else {
                                                    this.setState(() => ({
                                                        IP: []
                                                    }))
                                                }
                                            }
                                        )
                                }
                                if (this.state.chooseAddCompanyName != '请选择公司' && this.state.chooseAddProductName != '请选择产品' && this.state.chooseAddProjectName != "请选择项目") {
                                    this.setState(()=>({
                                        chooseCompanyName:this.state.chooseAddCompanyName,
                                        chooseProductName:this.state.chooseAddProductName,
                                        chooseProjectName:this.state.chooseAddProjectName,
                                        chooseCompanyId:this.state.chooseAddCompanyId,
                                        chooseProductId:this.state.chooseAddProductId,
                                        chooseProjectId:this.state.chooseAddProjectId
                                    }))
                                    fetchPost(global.constants.getPatentByProject, {projectId: this.state.chooseProjectId})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        IP: res.data,
                                                    }))
                                                } else {
                                                    this.setState(() => ({
                                                        IP: []
                                                    }))
                                                }
                                            }
                                        )
                                }
                            }
                            else{
                                message.info('该知识产权已经添加，请检查知识产权名称！').then()
                            }                        }
                    )
            }
            }
    }
    // cancelCompanyName(){
    //     this.setState(()=>({
    //         chooseCompanyName:'请选择公司',
    //         chooseProductName:'请选择产品',
    //         chooseProjectName:'请选择项目',
    //         productNames:[],
    //         projectNames:[],
    //         chooseProductButtonDisabled:false,
    //     }))
    //     fetchPost(global.constants.getAllPatent,{})
    //         .then(
    //             res => {
    //                 if(res.code === 200) {
    //                     this.setState(()=>({
    //                         IP:res.data,
    //                     }))
    //                 }
    //             }
    //         )
    // }
    // cancelProductName(){
    //     this.setState(()=>({
    //         chooseProductName:'请选择产品',
    //         chooseProjectName:'请选择项目',
    //         projectNames:[],
    //     }))
    //     fetchPost(global.constants.getProjectNameByCompanyNameList,{companyName:this.state.chooseCompanyName})
    //         .then(
    //             res => {
    //                 if(res.code === 200) {
    //                     this.setState(()=>({
    //                         projectNames:res.data,
    //                     }))
    //                 }
    //             }
    //         )
    // }
    // cancelProjectName(){
    //     this.setState(()=>({
    //         chooseProjectName:'请选择项目',
    //         chooseProductButtonDisabled:false,
    //     }))
    // }
    chooseAddCompany = (e)=>{
        const value = e
        this.setState(()=>({
            chooseAddCompanyName:value,
            obligee:value,
            chooseAddProductName:'请选择产品',
            chooseAddProjectName:'请选择项目',
            add_visible:true,
        }))
        this.state.companyNames.find((obj) => {
            if (obj.companyName === value) {
                this.setState(() => ({
                    chooseAddCompanyId: obj.id
                }))
                //获取该公司所有产品的名字
                fetchPost(global.constants.getCompanyProductList, {companyId: obj.id})
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    addProductNames: res.data,
                                }))
                            } else {
                                message.info("该公司没有产品").then()
                                this.setState(() => ({
                                    addProductNames: [],
                                }))
                            }
                        }
                    )
                //获取直接属于该公司的项目名称
                fetchPost(global.constants.getProjectByCompany, {companyId: obj.id})
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    addProjectNames: res.data,
                                }))
                            } else {
                                this.setState(() => ({
                                    addProjectNames: [],
                                }))
                            }
                        }
                    )
            }})
    }
    chooseAddProduct = (e)=>{
        const value = e
        this.setState(()=>({
            chooseAddProductName:value,
            chooseAddProjectName:"请选择项目",
        }))
        this.state.addProductNames.find((obj) => {
            if (obj.productName === value) {
                this.setState(() => ({
                    chooseAddProductId: obj.id
                }))
                let params = {
                    companyId: this.state.chooseAddCompanyId,
                    productId: obj.id,   //不要用state的值，异步的！异步的！异步的！
                }
                fetchPost(global.constants.getProjectByProduct, params)
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    addProjectNames: res.data,
                                }))
                            } else {
                                message.info("该产品没有项目")
                                this.setState(() => ({
                                    addProjectNames: []
                                }))

                            }
                        }
                    )
            }})
    }
    chooseAddProject = (e)=>{
        const value = e
        this.setState(()=>({
            chooseAddProjectName:value
        }))
        this.state.addProjectNames.find((obj) => {
            if (obj.projectName === value) {
                this.setState(() => ({
                    chooseAddProjectId: obj.id
                }))
            }})
    }
    formRef = React.createRef();
    onReset = () => {
        this.formRef.current.resetFields();
    };
    render() {
        const category_menu = (
            <Menu>
                <Menu.Item onClick={this.categoryChange.bind(this,'发明专利','A','Ⅰ')}>
                    A发明专利（含国防专利）
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'植物新品种','B','Ⅰ')}>
                    B植物新品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'国家级农作物品种','C','Ⅰ')}>
                    C国家级农作物品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'国家新药','D','Ⅰ')}>
                    D国家新药
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'国家一级中药保护品种','E','Ⅰ')}>
                    E国家一级中药保护品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'集成电路布图设计专有权','F','Ⅰ')}>
                    F集成电路布图设计专有权
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'实用新型专利','G','Ⅱ')}>
                    G实用新型专利
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'外观设计专利','H','Ⅱ')}>
                    H外观设计专利
                </Menu.Item>
                <Menu.Item onClick={this.categoryChange.bind(this,'软件著作权','I','Ⅱ')}>
                    I软件著作权
                </Menu.Item>
            </Menu>
        )
        const accessName_menu = (
            <Menu>
                <Menu.Item onClick={this.accessNameChange.bind(this,'自主研发','A')}>
                    自主研发
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChange.bind(this,'受让','B')}>
                    受让
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChange.bind(this,'受赠','B')}>
                    受赠
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChange.bind(this,'并购','B')}>
                    并购
                </Menu.Item>
            </Menu>
        );
        const newCategory_menu = (
            <Menu>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'发明专利','A','Ⅰ')}>
                A发明专利（含国防专利）
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'植物新品种','B','Ⅰ')}>
                B植物新品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'国家级农作物品种','C','Ⅰ')}>
                    C国家级农作物品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'国家新药','D','Ⅰ')}>
                    D国家新药
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'国家一级中药保护品种','E','Ⅰ')}>
                    E国家一级中药保护品种
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'集成电路布图设计专有权','F','Ⅰ')}>
                    F集成电路布图设计专有权
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'实用新型专利','G','Ⅱ')}>
                    G实用新型专利
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'外观设计专利','H','Ⅱ')}>
                    H外观设计专利
                </Menu.Item>
                <Menu.Item onClick={this.categoryChangeNew.bind(this,'软件著作权','I','Ⅱ')}>
                    I软件著作权
                </Menu.Item>
            </Menu>
        );
        const newAccessName_menu = (
            <Menu>
                <Menu.Item onClick={this.accessNameChangeNew.bind(this,'自主研发','A')}>
                    自主研发
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChangeNew.bind(this,'受让','B')}>
                    受让
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChangeNew.bind(this,'受赠','B')}>
                    受赠
                </Menu.Item>
                <Menu.Item onClick={this.accessNameChangeNew.bind(this,'并购','B')}>
                    并购
                </Menu.Item>
            </Menu>
        )

        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="知识产权列表"
                            subTitle={"请选择公司、产品与项目查找知识产权"}
                            extra={[
                                <Button
                                    type="primary"
                                    onClick={this.handleAddClick}
                                >
                                    添加知识产权
                                </Button>
                            ]}
                        >
                        </PageHeader>
                    </div>
                    <Paragraph>
                        <pre>Tips：如果知识产权不属于任何产品或项目，可以不选；选择完成后，点击查找。添加知识产权时同理。</pre>
                    </Paragraph>
                <Space direction="vertical" className="content-style" >
                    <div>
                        <div>
                            <Select showSearch
                                    style={{ width: 250 }}
                                    placeholder="请选择公司"
                                    defaultValue={this.state.chooseCompanyName}
                                    value={this.state.chooseCompanyName}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseCompany.bind(this)}
                            >
                                {this.state.companyNames.map(item => (
                                    <Option key={item.companyName} value={item.companyName}>
                                        {item.companyName}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 250 }}
                                    placeholder="请选择产品"
                                    value={this.state.chooseProductName}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseProduct.bind(this)}
                            >
                                {this.state.productNames.map(item => (
                                    <Option key={item.productName} value={item.productName}>
                                        {item.productName}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 350 }}
                                    placeholder="请选择项目"
                                    value={this.state.chooseProjectName}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseProject.bind(this)}
                            >
                                {this.state.projectNames.map(item => (
                                    <Option key={item.projectName} value={item.projectName} >
                                        {item.projectName}
                                    </Option>
                                ))}
                            </Select>
                            <Button
                                className='Search_button'
                                icon={<SearchOutlined/>}
                                onClick={this.state.searchStatus === true ? this.getIPList:this.clearPath.bind(this)}>
                                {this.state.searchStatus===true?'查找':'重新查找'}
                            </Button>
                            <Button
                                className='Search_button'
                                icon={<SearchOutlined/>}
                                onClick={this.getAllPatentByCompany.bind(this)}>
                                查找该公司所有产权
                            </Button>
                        </div>
                        {/*<div>*/}
                        {/*     <Tag color="geekblue" className="Tag_style">{this.state.chooseCompanyName}*/}
                        {/*        <Button size="small"*/}
                        {/*                type="dashed"*/}
                        {/*                shape="circle"*/}
                        {/*                style={{marginLeft:'5px'}}*/}
                        {/*                icon={<CloseOutlined style={{fontSize:'10px'}}/> }*/}
                        {/*                onClick={this.cancelCompanyName}/></Tag>*/}
                        {/*    <Tag color="orange" className="Tag_style">{this.state.chooseProductName}*/}
                        {/*        <Button size="small"*/}
                        {/*                type="dashed"*/}
                        {/*                shape="circle"*/}
                        {/*                style={{marginLeft:'5px'}}*/}
                        {/*                icon={<CloseOutlined style={{fontSize:'10px'}}/> }*/}
                        {/*                onClick={this.cancelProductName}/></Tag>*/}
                        {/*    <Tag color="green" className="Tag_style">{this.state.chooseProjectName}*/}
                        {/*        <Button*/}
                        {/*            size="small"*/}
                        {/*            type="dashed"*/}
                        {/*            shape="circle"*/}
                        {/*            style={{marginLeft:'5px'}}*/}
                        {/*            icon={<CloseOutlined style={{fontSize:'10px'}}/> }*/}
                        {/*            onClick={this.cancelProjectName}/></Tag>*/}
                        {/*</div>*/}
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IP} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">知识产权名称</p>} dataIndex="patentName" key="patentName"/>
                            <Column align="center" title={<p className="list-column-style">种类</p>} dataIndex="category" key="category" />
                            <Column align="center"
                                    title={<p className="list-column-style">状态</p>}
                                    key="category"
                                    render={(record)=>record.status === 1?'已授权':'申请中' }/>
                            <Column align="center" title={<p className="list-column-style">获得方式</p>} dataIndex="accessName" key="accessName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleEditClick.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDeleteClick.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'修改知识产权信息'}
                    onOk={this.uploadIP}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadIP}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="知识产权名称" name="newPatentName" >
                            <Input defaultValue={this.state.newPatentName} onChange={(e) => this.patentNameChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="种类名称" name="newCategory" >
                            <Dropdown overlay={newCategory_menu} placement="bottomCenter" arrow trigger='click'>
                            <Button type="default" style={{marginRight:5}}>{this.state.newCategory}</Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="种类" name="newCategory_code" >
                            <div>{this.state.newCategoryCode}</div>
                        </Form.Item>
                        <Form.Item label="类别" name="newCategory" >
                            <div>{this.state.newType}</div>
                        </Form.Item>
                        <Form.Item label="状态" name="newStatus" >
                            <Radio.Group name="status" defaultValue={this.state.newStatus} onChange={(e) => this.statusChangeNew(e.target.value)}>
                                <Radio value={1}>已授权</Radio>
                                <Radio value={0}>受理中</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="申请号" name="newApplyNumber">
                            <Input
                                defaultValue={this.state.newApplyNumber}
                                onChange={(e) => this.applyNumberChangeNew(e.target.value)}
                                disabled={this.state.newStatus == 1 ?true:false}
                            /></Form.Item>
                        <Form.Item label="授权号" name="newAuthorizationNumber">
                            <Input defaultValue={this.state.newAuthorizationNumber}
                                   onChange={(e) => this.authorizationNumberChangeNew(e.target.value)}
                                   disabled={this.state.newStatus == 1 ?false:true}
                            /></Form.Item>
                        <Form.Item
                            label="申请时间"
                            name="newApplyTime"
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    defaultValue={moment(this.state.newApplyTime)} //默认值要求moment格式
                                    format={'YYYY-MM-DD'}
                                    onChange={this.applyTimeChangeNew}
                                    disabled={this.state.newStatus == 1 ?true:false}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item
                            label="授权时间"
                            name="newAuthorizationTime"
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    defaultValue={moment(this.state.newAuthorizationTime)} //默认值要求moment格式
                                    format={'YYYY-MM-DD'}
                                    onChange={this.authorizationTimeChangeNew}
                                    disabled={this.state.newStatus == 1 ?false:true}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="获得方式名称" name="newAccessName" >
                            <Dropdown overlay={newAccessName_menu} placement="bottomCenter" arrow trigger='click'>
                                <Button type="default" style={{marginRight:5}}>{this.state.newAccessName}</Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="获得方式" name="newAccess" >
                            <div>{this.state.newAccess}</div>
                        </Form.Item>
                        <Form.Item label="权利人" name="newObligee" >
                            <Input defaultValue={this.state.newObligee} onChange={(e) => this.obligeeChangeNew(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="与网上法律状态" name="newLegalStatus" >
                            <Radio.Group defaultValue={this.state.newLegalStatus} name="legalStatus" onChange={(e) => this.legalStatusChangeNew(e.target.value)}>
                                <Radio value={'A'}>A相同</Radio>
                                <Radio value={'B'}>B不同</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="历史申请认定是否使用过该专利" name="newHistory" >
                            <Radio.Group defaultValue={this.state.newHistory} name="history" onChange={(e) => this.historyChangeNew(e.target.value)}>
                                <Radio value={'是'}>是</Radio>
                                <Radio value={'否'}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加知识产权'}
                    onOk={this.addIP}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addIP}>
                            提交
                        </Button>,
                    ]}
                >
                    <div>
                        <Select showSearch
                                style={{ width: 350,marginBottom:10 }}
                                placeholder="请选择公司"
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                value={this.state.chooseAddCompanyName}
                                onSelect={this.chooseAddCompany.bind(this)}
                        >
                            {this.state.companyNames.map(item => (
                                <Option key={item.companyName} value={item.companyName}>
                                    {item.companyName}
                                </Option>
                            ))}
                        </Select>
                        <Select showSearch
                                style={{ width: 350,marginBottom:10 }}
                                placeholder="请选择产品"
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                value={this.state.chooseAddProductName}
                                onSelect={this.chooseAddProduct.bind(this)}
                        >
                            {this.state.addProductNames.map(item => (
                                <Option key={item.productName} value={item.productName} >
                                    {item.productName}
                                </Option>
                            ))}
                        </Select>
                        <Select showSearch
                                style={{ width: 350,marginBottom:10}}
                                placeholder="请选择项目"
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                searchPlaceholder="输入关键词"
                                value={this.state.chooseAddProjectName}
                                onChange={this.chooseAddProject.bind(this)}
                        >
                            {this.state.addProjectNames.map(item => (
                                <Option key={item.projectName} value={item.projectName} >
                                    {item.projectName}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <Form name="control-hooks" ref={this.formRef}>
                        {/*<Form.Item  name="choose" rules={[{ required: true, message: '请选择公司!' }]}>*/}
                        {/*    */}
                        {/*</Form.Item>*/}
                        <Form.Item label="知识产权名称" name="patentName" rules={[{ required: true, message: '请输入知识产权名称!' }]}>
                            <Input
                                onChange={(e) => this.patentNameChange(e.target.value)}
                                // onBlur={this.checkIP.bind(this)}
                            /></Form.Item>
                        <Form.Item label="种类名称" name="category" rules={[{ required: true, message: '请输入种类!' }]}>
                            <Dropdown overlay={category_menu} placement="bottomCenter" arrow trigger='click'>
                                <Button type="default" style={{marginRight:5}}>{this.state.category}</Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="种类" name="category_code" rules={[{ required: true}]}>
                            <div>{this.state.categoryCode}</div>
                        </Form.Item>
                        <Form.Item label="类别" name="type" rules={[{ required: true }]}>
                            <div>{this.state.type}</div>
                        </Form.Item>
                        <Form.Item label="状态" name="status" rules={[{ required: true, message: '请输入状态!' }]}>
                            <Radio.Group name="status"  onChange={(e) => this.statusChange(e.target.value)}>
                                <Radio value={1}>已授权</Radio>
                                <Radio value={0}>受理中</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="申请号"
                            name="applyNumber"
                            rules={[{ required: true, message: '请输入申请号!' }]}
                        >
                            <Input disabled={this.state.status == 1 ?true:false} onChange={(e) => this.applyNumberChange(e.target.value)}/></Form.Item>
                        <Form.Item
                            label="授权号"
                            name="authorizationNumber"
                            rules={[{ required: true, message: '请输入授权号!' }]}
                        >
                            <Input disabled={this.state.status == 1 ?false:true} onChange={(e) => this.authorizationNumberChange(e.target.value)}/></Form.Item>
                        <Form.Item
                            label="申请时间"
                            name="applyTime"
                            rules={[{ required: true, message: '请输入申请时间!' }]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.applyTimeChange}
                                    disabled={this.state.status == 1 ?true:false}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item
                            label="授权时间"
                            name="authorizationTime"
                            rules={[{ required: true, message: '请输入授权时间!' }]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.authorizationTimeChange}
                                    disabled={this.state.status == 1 ?false:true}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="获得方式名称" name="accessName" rules={[{ required: true, message: '请输入获得方式名称!' }]}>
                            <Dropdown overlay={accessName_menu} placement="bottomCenter" arrow trigger='click'>
                                <Button type="default" style={{marginRight:5}}>{this.state.accessName}</Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="获得方式" name="access" rules={[{ required: true, message: '请输入获得方式!' }]}>
                            <div>{this.state.access}</div>
                        </Form.Item>
                        <Form.Item id='obligee' label="权利人" name="obligee" rules={[{ required: true, message: '请输入权利人!' }]}>
                            <p style={{display:'none'}}>{this.state.obligee}</p>
                            <Input  value={this.state.obligee} onChange={(e) => this.obligeeChange(e.target.value)}/>
                        </Form.Item>
                        <Form.Item label="与网上法律状态" name="legalStatus" rules={[{ required: true, message: '请选择与网上法律状态!' }]}>
                            <Radio.Group name="legalStatus" onChange={(e) => this.legalStatusChange(e.target.value)}>
                                <Radio value={'A'}>A相同</Radio>
                                <Radio value={'B'}>B不同</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="历史申请认定是否使用过该专利" name="history" rules={[{ required: true, message: '请选择历史申请认定是否使用过该专利!' }]}>
                            <Radio.Group name="history" onChange={(e) => this.historyChange(e.target.value)}>
                                <Radio value={'是'}>是</Radio>
                                <Radio value={'否'}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item >
                            <Button key="reset" onClick={this.onReset.bind(this)} style={{float:'right'}}>
                                继续添加
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteIP}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteIP}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该知识产权吗？</div>
                </Modal>
            </div>
            </div>
        )
    }

    patentNameChange(e) {
        this.setState(()=>({
            patentName:e
        }))
    }
    categoryChange(e,a,b){
        const value = e
        this.setState(()=>({
            category:value,
            categoryCode:a,
            type:b,
        }))
    }
    applyNumberChange(e) {
        this.setState(()=>({
            applyNumber:e
        }))
    }
    authorizationNumberChange(e) {
        this.setState(()=>({
            authorizationNumber:e
        }))
    }
    applyTimeChange=(value,dateString)=>{
        this.setState({
            applyTime:dateString
        })
    }
    authorizationTimeChange=(value,dateString)=>{
        this.setState({
            authorizationTime:dateString
        })
    }
    accessNameChange(e,b){
        const value = e
        this.setState(()=>({
            accessName:value,
            access:b
        }))
    }
    obligeeChange(e){
        this.setState(()=>({
            obligee:e
        }))
    }
    legalStatusChange(e){
        this.setState(()=>({
            legalStatus:e
        }))
    }
    historyChange(e){
        this.setState(()=>({
            history:e
        }))
    }
    statusChange(e) {
        this.setState(()=>({
            status:e,
            authorizationTimeDisabled:false,
        }))
    }
    patentNameChangeNew(e) {
        this.setState(()=>({
            newPatentName:e
        }))
    }
    categoryChangeNew(e,a,b){
        const value = e
        this.setState(()=>({
            newCategory:value,
            newCategoryCode:a,
            newType:b,
        }))
    }
    applyNumberChangeNew(e) {
        this.setState(()=>({
            newApplyNumber:e
        }))
    }
    authorizationNumberChangeNew(e) {
        this.setState(()=>({
            newAuthorizationNumber:e
        }))
    }
    applyTimeChangeNew=(value,dateString)=> {
        this.setState(()=>({
            newApplyTime:dateString
        }))
    }
    authorizationTimeChangeNew=(value,dateString)=> {
        this.setState(()=>({
            newAuthorizationTime:dateString
        }))
    }
    accessNameChangeNew(e,b) {
        const value = e
        this.setState(()=>({
            newAccessName:value,
            newAccess:b
        }))
    }
    obligeeChangeNew(e){
        this.setState(()=>({
            newObligee:e
        }))
    }
    legalStatusChangeNew(e){
        this.setState(()=>({
            newLegalStatus:e
        }))
    }
    historyChangeNew(e){
        this.setState(()=>({
            newHistory:e
        }))
    }
    statusChangeNew(e) {
        this.setState(()=>({
            newStatus:e,
            authorizationTimeDisabled:false,
        }))
    }
}
export default IPList;